import App from './App.svelte'

const app = new App({
  target: document.body,
  props: {
    name: 'SM4 File Manager'
  }
})

export default app
